import { useState, useEffect } from "react";

const STORAGE_PREFIX = "campaign-analysis-accordion:";

const readStoredOpen = (storageKey, defaultOpen) => {
  if (!storageKey || typeof window === "undefined") {
    return defaultOpen;
  }
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${storageKey}`);
    if (raw === null) {
      return defaultOpen;
    }
    return raw === "1";
  } catch (e) {
    return defaultOpen;
  }
};

const CampaignAnalysisAccordion = ({
  title,
  subtitle,
  defaultOpen = true,
  storageKey = null,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(() =>
    readStoredOpen(storageKey, defaultOpen),
  );

  useEffect(() => {
    if (!storageKey) {
      return;
    }
    try {
      sessionStorage.setItem(
        `${STORAGE_PREFIX}${storageKey}`,
        isOpen ? "1" : "0",
      );
    } catch (e) {
      // ignore quota / private mode
    }
  }, [isOpen, storageKey]);

  return (
    <section className="campaign-analysis-accordion">
      <button
        type="button"
        className="campaign-analysis-accordion__header"
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
      >
        <div className="campaign-analysis-accordion__header-text">
          <h2 className="campaign-analysis-accordion__title">
            <span>{title}</span>
            <i
              className={`fas fa-chevron-up campaign-analysis-accordion__chevron ${
                isOpen ? "" : "campaign-analysis-accordion__chevron--collapsed"
              }`}
              aria-hidden
            />
          </h2>
          {subtitle ? (
            <p className="campaign-analysis-accordion__subtitle">{subtitle}</p>
          ) : null}
        </div>
      </button>
      {isOpen ? (
        <div className="campaign-analysis-accordion__content">{children}</div>
      ) : null}
    </section>
  );
};

export default CampaignAnalysisAccordion;
